import { transparentize } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'wouter';
import { Colors, toRem } from '.';
import { LFC } from '../Legacy';

const Base = styled.table<{ disableSelect?: boolean }>`
    width: 100%;
    border-radius: .5rem;
    background: #fff;
    border: solid .125rem #F0F2F5;
    border-radius: .125rem;
    color: ${Colors.text};

    ${p => p.disableSelect && css`
        user-select: none;
    `}
`;

const Row = styled.tr<{ clickable?: boolean, selected?: boolean }>`
    border-bottom: var(--row-border, solid .125rem #F0F2F5);

    ${p => !p.clickable ? '' : css`
        cursor: pointer;
        input[type=checkbox] {
            cursor: pointer;
        }

        &:hover {
            background: var(--row-hover-bg, none);
            box-shadow: var(--row-hover-shadow, 0 0 0 .1875rem #F0F2F5);
        }

        &:active {
            background: var(--row-active-bg, none);
            box-shadow: var(--row-active-shadow, none);
        }
    `}

    ${p => !p.selected ? '' : css`
        background: var(--row-selected-bg, none) !important;
        box-shadow: var(--row-selected-shadow, none) !important;
    `}
`;

const Cell = styled.td<{ width?: any }>`
    padding: var(--cell-padding, .5rem 1rem);
    ${p => p.width ? `width: ${toRem(p.width)}` : ''}; 
`;

const CellWithLink = styled.td<{ width?: any }>`
    ${p => p.width ? `width: ${toRem(p.width)}` : ''}; 
    & > a {
        display: block;
        padding: .5rem 1rem;
        width: 100%;
        height:100%;
    }
`;

const LinkCell: LFC<{ to: string }> = ({ to, children }) =>
    <CellWithLink>
        <Link to={to}>
            {children}
        </Link>

    </CellWithLink>;

const HeadCell = styled.td<{ width?: any, clickable?: boolean }>`
    padding: var(--cell-padding, .5rem 1rem);
    ${p => p.width ? `width: ${toRem(p.width)}` : ''}; 
    ${p => p.clickable && css`
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
    `}
`;

const SortIndicator = ({ sort }: { sort?: 'asc' | 'desc' | false }) => <>
    {sort === 'asc' && <span style={{ marginLeft: '.25rem' }}>{'▲'}</span>}
    {sort === 'desc' && <span style={{ marginLeft: '.25rem' }}>{'▼'}</span>}
</>;

const Head = styled.thead`
    ${Cell} {
        color: ${Colors.primaryText};
        font-size: .875rem;
        font-weight: 500;
        text-transform: uppercase;
    }
`;

const Body = styled.tbody`
    
`;

export const Table = Object.assign(Base, { Head, Body, Row, Cell, LinkCell, HeadCell, SortIndicator });

export const CoolTableTheme = styled.div`

    --row-border: none;
    --row-hover-bg: ${transparentize(0.5, Colors.hover)};
    --row-hover-shadow: none;
    --row-active-bg: ${transparentize(0.25, Colors.hover)};
    --row-selected-bg: ${transparentize(0.5, Colors.hover)};
    --cell-padding: .5rem;

    ${Base} {
        border: none;
    }

    ${Head} {

        ${Row} {
            border-bottom: none;
        }

        td {
            background: ${Colors.hover};
            color: ${Colors.text};
            font-size: .875rem;
            font-weight: 500;
            text-transform: none;

            &:first-child {
                border-radius: .25rem 0 0 .25rem;
            }

            &:last-child {
                border-radius: 0 .25rem .25rem 0;
            }
        }
    }
`;
